import { render, staticRenderFns } from "./PageIssues.vue?vue&type=template&id=0d308fcb&"
import script from "./PageIssues.vue?vue&type=script&lang=js&"
export * from "./PageIssues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports